import { createSlice } from "@reduxjs/toolkit";

import {
  getUtilityThunk,
  createUtilityThunk,
  updateUtilityThunk,
  deleteUtilityThunk,
} from "state/action/utility";

// Initial state
const initialState = {
  // Get Utility inisial state
  getUtility: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  // Create Utility inisial state
  createUtility: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  // Update Utility inisial state
  updateUtility: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  // Delete Utility inisial state
  deleteUtility: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  createUtilityInputBody: {
    property: "",
    unit: "",
    building: "",
    utility: "",
    utility_type: "",
    floor: "",
    utility_period: "",
    invoice_period: "",
    charge: "",
    rate: "",
    meter_no: "",
    start_date: "",
    end_date: "",
    meter: {
      meter_start: "",
      meter_end: "",
      meter_usage: "",
    },
    beban_bersama: "",
    status: "",
  },
  filterUtilityQueryParams: {
    property: "",
    utility: "",
    utility_period: "",
  },
  selectedUtilityElectricityData: {
    property: "",
    unit: "",
    building: "",
    utility: "",
    utility_type: "",
    floor: "",
    utility_period: "",
    invoice_period: "",
    charge: "",
    rate: "",
    meter_no: "",
    start_date: "",
    end_date: "",
    meter: {
      meter_start: "",
      meter_end: "",
      meter_usage: "",
      meter_charge: "",
    },
    beban_bersama: "",
    status: "",
  },
  selectedUtilityWaterData: {
    property: "",
    unit: "",
    building: "",
    utility: "",
    utility_type: "",
    floor: "",
    utility_period: "",
    invoice_period: "",
    charge: "",
    rate: "",
    meter_no: "",
    start_date: "",
    end_date: "",
    meter: {
      meter_start: "",
      meter_end: "",
      meter_usage: "",
      meter_charge: "",
    },
    beban_bersama: "",
    status: "",
  },
  // Utility object value
  utility_object_value: "",
};

export const utilitySlice = createSlice({
  name: "utility",
  initialState,
  reducers: {
    setGetUtilityObjectValue: (state, action) => {
      return {
        ...state,
        utility_object_value: action.payload,
      };
    },
    setCreateUtilityInputBody: (state, action) => {
      return {
        ...state,
        createUtilityInputBody: action.payload,
      };
    },
    setFilterUtilityQueryParams: (state, action) => {
      return {
        ...state,
        filterUtilityQueryParams: action.payload,
      };
    },
    setSelectedUtilityElectricityData: (state, action) => {
      return {
        ...state,
        selectedUtilityElectricityData: action.payload,
      };
    },
    setSelectedUtilityWaterData: (state, action) => {
      return {
        ...state,
        selectedUtilityWaterData: action.payload,
      };
    },
    setClearSelectedUtilityElectricityData: (state, _) => {
      return {
        ...state,
        selectedUtilityElectricityData: null,
      };
    },
    setClearSelectedUtilityWaterData: (state, _) => {
      return {
        ...state,
        selectedUtilityWaterData: null,
      };
    },
    // note: clear state
    setClearGetUtilityObjectValue: (state, _) => {
      return {
        ...state,
        utility_object_value: "",
      };
    },
    setClearGetUtility: (state, _) => {
      return {
        ...state,
        getUtility: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearCreateUtilityInputBody: (state, _) => {
      return {
        ...state,
        createUtilityInputBody: {
          property: "",
          unit: "",
          building: "",
          utility: "",
          utility_type: "",
          floor: "",
          utility_period: "",
          invoice_period: "",
          charge: "",
          rate: "",
          meter_no: "",
          start_date: "",
          end_date: "",
          meter: {
            meter_start: "",
            meter_end: "",
            meter_usage: "",
          },
          beban_bersama: "",
          status: "",
        },
      };
    },
    setClearCreateUtility: (state, _) => {
      return {
        ...state,
        createUtility: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearUpdateUtility: (state, _) => {
      return {
        ...state,
        updateUtility: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearDeleteUtility: (state, _) => {
      return {
        ...state,
        deleteUtility: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearAllUtilityState: (state, _) => {
      return {
        ...state,
        // Get Utility inisial state
        getUtility: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Create Utility inisial state
        createUtility: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Update Utility inisial state
        updateUtility: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Delete Utility inisial state
        deleteUtility: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Utility object value
        utility_object_value: "",
      };
    },
  },
  extraReducers(builder) {
    builder
      // Get Utility reducer
      .addCase(getUtilityThunk.pending, (state, _) => {
        return {
          ...state,
          getUtility: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(getUtilityThunk.fulfilled, (state, action) => {
        return {
          ...state,
          getUtility: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(getUtilityThunk.rejected, (state, action) => {
        return {
          ...state,
          getUtility: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      })
      // Create Utility reducer
      .addCase(createUtilityThunk.pending, (state, _) => {
        return {
          ...state,
          register: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(createUtilityThunk.fulfilled, (state, action) => {
        return {
          ...state,
          register: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(createUtilityThunk.rejected, (state, action) => {
        return {
          ...state,
          register: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      })
      // update Utility reducer
      .addCase(updateUtilityThunk.pending, (state, _) => {
        return {
          ...state,
          updateUtility: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(updateUtilityThunk.fulfilled, (state, action) => {
        return {
          ...state,
          updateUtility: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(updateUtilityThunk.rejected, (state, action) => {
        return {
          ...state,
          updateUtility: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      });
  },
});

export const utilityAction = {
  ...utilitySlice.actions,
  getUtilityThunk,
  createUtilityThunk,
  updateUtilityThunk,
  deleteUtilityThunk,
};

export function selectUtilityObjectValue(state) {
  return state?.utility?.utility_object_value;
}

export function selectUtility(state) {
  return state?.utility;
}

export default utilitySlice.reducer;
